export const state = {
  offerUuid: null,
  offerApplicantData: false,
  offerFailed: false,
  offer: {},
  shouldMockOffer: false
};
